// sizingOptimizationApiSlice.js
import { createEntityAdapter } from "@reduxjs/toolkit";
import { DateTime } from "luxon";
import apiSlice from "../api/apiSlice";

// Create an adapter for the sizing optimization
const sizingOptimizationAdapter = createEntityAdapter({});

// Inject endpoints for the sizing optimization slice
export const sizingOptimizationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    buildAndSimulatePayload: builder.mutation({
      query: ({ communityId, payload }) => ({
        url: `/communities/${communityId}/payload/build_and_simulate`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
        validateStatus: () => true,
      }),
      transformResponse: (responseData) => responseData,
      invalidatesTags: (result) => {
        if (result?.ids) {
          return [
            { type: "SizingOptimization", id: "LIST" },
            ...result.ids.map((id) => ({ type: "SizingOptimization", id })),
          ];
        }
        return [{ type: "SizingOptimization", id: "LIST" }];
      },
    }),

    /* GET Sizing Simulation Results */
    getSizingSimulationResults: builder.query({
      query: ({ communityId, startDate, endDate, meterId }) => {
        // Build query parameters
        const queryParams = new URLSearchParams();
        if (startDate)
          queryParams.append("start_date", DateTime.fromISO(startDate).toFormat("yyyy-MM-dd"));
        if (endDate)
          queryParams.append("end_date", DateTime.fromISO(endDate).toFormat("yyyy-MM-dd"));
        if (meterId) queryParams.append("meter_id", meterId);

        return {
          url: `/communities/${communityId}/sizing_simulation/results?${queryParams.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (responseData) => responseData,
      providesTags: (result, error, { communityId }) => [
        { type: "SizingSimulation", id: communityId },
      ],
    }),
  }),
});

// Export hooks to use these queries/mutations in components
export const { useBuildAndSimulatePayloadMutation, useGetSizingSimulationResultsQuery } =
  sizingOptimizationApiSlice;

export const { selectAll: selectAllSizingOptimizations } = sizingOptimizationAdapter.getSelectors();
